module.exports = __webpack_public_path__ + "static/img/right-home-row-7.c4f36654.png";